module.exports = __webpack_public_path__ + "vitals-settings-edit-bde2b43af1a37dded5ef7005eb91a4ed.gif";